import React from "react";
import { Button } from "react-bootstrap";
import { FaCheck } from "react-icons/fa6";
import { formatRupees } from "../../../utils/currency";

const DEFAULT_FEATURES = [
  "AI-drafted name, description & attributes",
  "Front + back photo input",
  "Editable drafts — publish when ready",
];

const DEFAULT_TAGLINES = {
  boutique: "For a new store finding its feet online.",
  label: "For a growing store building its own label.",
  brand: "For an established fashion brand at scale.",
};

const PlanCard = ({
  plan,
  isCurrent,
  isScheduled,
  scheduledStartDate,
  isProcessing,
  onSubscribe,
  onCancelUpgrade,
  hidePopular,
}) => {
  const perListing = plan?.metadata?.perListingPriceInPaise;
  const topupPriceInPaise = plan?.metadata?.topupPriceInPaise;
  const features = plan?.metadata?.features?.length
    ? plan.metadata.features
    : DEFAULT_FEATURES;

  let badge = null;
  let variant = null;
  if (isCurrent) {
    badge = "Active";
    variant = "active";
  } else if (isScheduled) {
    badge = scheduledStartDate ? `Starts ${scheduledStartDate}` : "Coming up";
    variant = "scheduled";
  } else if (plan.isPopular && !hidePopular) {
    badge = "Most popular";
    variant = "popular";
  }

  return (
    <div
      className={[
        "billing-card",
        variant ? `is-highlight is-${variant}` : "",
        isCurrent ? "is-current" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {badge && <span className="billing-card-badge">{badge}</span>}

      <div className="billing-card-head">
        <div className="billing-card-name">{plan.name}</div>
        {(plan.description || DEFAULT_TAGLINES[plan.code]) && (
          <div className="billing-card-sub">
            {plan.description || DEFAULT_TAGLINES[plan.code]}
          </div>
        )}
      </div>

      <div className="billing-card-price">
        {formatRupees(plan.priceInPaise)}
        <span className="billing-card-period">/ month</span>
      </div>

      <div className="billing-card-quota">
        <div className="billing-card-quota-main">
          {plan.monthlyListings} credits / month
        </div>
        {perListing != null && (
          <div className="billing-card-quota-sub">
            just {formatRupees(perListing)} per credit
            {topupPriceInPaise != null && (
              <> · extra at {formatRupees(topupPriceInPaise)}</>
            )}
          </div>
        )}
      </div>

      <ul className="billing-feature-list">
        {features.map((f, i) => (
          <li key={i}>
            <FaCheck className="billing-check" /> {f}
          </li>
        ))}
      </ul>

      {isScheduled ? (
        <Button
          className="billing-card-cta is-danger"
          onClick={onCancelUpgrade}
          disabled={!onCancelUpgrade}
        >
          Cancel switch
        </Button>
      ) : (
        <Button
          className="billing-card-cta"
          disabled={isCurrent || isProcessing}
          onClick={() => onSubscribe(plan)}
        >
          {isCurrent
            ? "Current plan"
            : isProcessing
            ? "Opening..."
            : `Choose ${plan.name}`}
        </Button>
      )}
    </div>
  );
};

export default PlanCard;
